import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../../../../API';
import { extractData } from '../../../../../utils/apiResponse';

function sortCases(list) {
    return [...list].sort((a, b) => {
        const aId = a?.networkIdentifier || a?.localIdentifier || '';
        const bId = b?.networkIdentifier || b?.localIdentifier || '';
        return String(aId).localeCompare(String(bId), undefined, { numeric: true, sensitivity: 'base' });
    });
}

/**
 * Shared case list query + navigation helpers.
 */
export function useCaseList(currentNetworkId) {
    const { data: caseListResponse, isLoading, error } = useQuery({
        queryKey: ['bdsa-case-list'],
        queryFn: () => api.get('bdsa/case'),
        staleTime: 5 * 60 * 1000,
    });

    const caseList = extractData(caseListResponse);
    const cases = useMemo(() => {
        const list = Array.isArray(caseList) ? caseList : [];
        return sortCases(list);
    }, [caseList]);

    const errorMessage = error ? (error.message || 'There was an error loading cases.') : null;

    const caseNav = useMemo(() => {
        if (!currentNetworkId || !cases.length) {
            return { prev: null, next: null, index: -1, total: 0 };
        }
        const index = cases.findIndex((c) => c?.networkIdentifier === currentNetworkId);
        return {
            prev: index > 0 ? cases[index - 1] : null,
            next: index >= 0 && index < cases.length - 1 ? cases[index + 1] : null,
            index,
            total: cases.length,
        };
    }, [cases, currentNetworkId]);

    return { cases, isLoading, error: errorMessage, caseNav };
}
